// Copy-paste from rc-calendar@9.7.8 calendar/CalendarHeader.jsx
// changes are marked with comments
/* eslint-disable */
import React from "react"
import createReactClass from "create-react-class"
import PropTypes from "prop-types"
import toFragment from "rc-util/lib/Children/mapSelf"
// change_start
import DecadePanel from "rc-calendar/es/decade/DecadePanel"
import MonthPanel from "./MonthPanel"
import YearPanel from "./YearPanel"
// changed_end

function goMonth(direction) {
  const next = this.props.value.clone()
  next.add(direction, "months")
  this.props.onValueChange(next)
}

function goYear(direction) {
  const next = this.props.value.clone()
  next.add(direction, "years")
  this.props.onValueChange(next)
}

function showIf(condition, el) {
  return condition ? el : null
}

const CalendarHeader = createReactClass({
  propTypes: {
    prefixCls: PropTypes.string,
    value: PropTypes.object,
    onValueChange: PropTypes.func,
    showTimePicker: PropTypes.bool,
    onPanelChange: PropTypes.func,
    locale: PropTypes.object,
    enablePrev: PropTypes.any,
    enableNext: PropTypes.any,
    disabledMonth: PropTypes.func,
  },

  getDefaultProps() {
    return {
      enableNext: 1,
      enablePrev: 1,
      onPanelChange() {},
      onValueChange() {},
    }
  },

  getInitialState() {
    this.nextMonth = goMonth.bind(this, 1)
    this.previousMonth = goMonth.bind(this, -1)
    this.nextYear = goYear.bind(this, 1)
    this.previousYear = goYear.bind(this, -1)
    return { yearPanelReferer: null }
  },

  onMonthSelect(value) {
    this.props.onPanelChange(value, "date")
    if (this.props.onMonthSelect) {
      this.props.onMonthSelect(value)
    } else {
      this.props.onValueChange(value)
    }
  },

  onYearSelect(value) {
    // change_start
    if (this.props.onYearSelect) {
      this.props.onYearSelect(value)
    } else {
      // const referer = this.state.yearPanelReferer;
      const referer = `month` // always go to month select whatever the referer is
      this.setState({ yearPanelReferer: null })
      this.props.onPanelChange(value, referer)
      this.props.onValueChange(value)
    }
    // change_end
  },

  onDecadeSelect(value) {
    this.props.onPanelChange(value, "year")
    this.props.onValueChange(value)
  },

  monthYearElement(showTimePicker) {
    const props = this.props
    const prefixCls = props.prefixCls
    const locale = props.locale
    const value = props.value
    const localeData = value.localeData()
    const monthBeforeYear = locale.monthBeforeYear
    const selectClassName = `${prefixCls}-${
      monthBeforeYear ? "my-select" : "ym-select"
    }`
    const timeClassName = showTimePicker ? ` ${prefixCls}-time-status` : ""
    const year = (
      <a
        className={`${prefixCls}-year-select${timeClassName}`}
        role="button"
        onClick={showTimePicker ? null : () => this.showYearPanel("date")}
        title={showTimePicker ? null : locale.yearSelect}
      >
        {value.format(locale.yearFormat)}
      </a>
    )
    const month = (
      <a
        className={`${prefixCls}-month-select${timeClassName}`}
        role="button"
        onClick={showTimePicker ? null : this.showMonthPanel}
        title={showTimePicker ? null : locale.monthSelect}
      >
        {locale.monthFormat
          ? value.format(locale.monthFormat)
          : localeData.monthsShort(value)}
      </a>
    )
    let day
    if (showTimePicker) {
      day = (
        <a className={`${prefixCls}-day-select${timeClassName}`} role="button">
          {value.format(locale.dayFormat)}
        </a>
      )
    }
    let my = []
    if (monthBeforeYear) {
      my = [month, day, year]
    } else {
      my = [year, month, day]
    }
    return <span className={selectClassName}>{toFragment(my)}</span>
  },

  showMonthPanel() {
    // null means that users' interaction doesn't change value
    this.props.onPanelChange(null, "month")
  },

  showYearPanel(referer) {
    this.setState({ yearPanelReferer: referer })
    this.props.onPanelChange(null, "year")
  },

  showDecadePanel() {
    this.props.onPanelChange(null, "decade")
  },

  render() {
    const { props } = this
    const {
      prefixCls,
      locale,
      mode,
      value,
      showTimePicker,
      enableNext,
      enablePrev,
      disabledMonth,
      // change_start
      disabledYear,
      // change_end
    } = props

    let panel = null
    if (mode === "month") {
      panel = (
        <MonthPanel
          locale={locale}
          defaultValue={value}
          rootPrefixCls={prefixCls}
          onSelect={this.onMonthSelect}
          onYearPanelShow={() => this.showYearPanel("month")}
          disabledDate={disabledMonth}
          cellRender={props.monthCellRender}
          contentRender={props.monthCellContentRender}
        />
      )
    }
    if (mode === "year") {
      panel = (
        <YearPanel
          locale={locale}
          defaultValue={value}
          rootPrefixCls={prefixCls}
          onSelect={this.onYearSelect}
          // change_start
          // onDecadePanelShow={this.showDecadePanel}
          disabledDate={disabledYear}
          cellRender={props.yearCellRender}
          contentRender={props.yearCellContentRender}
          // change_end
        />
      )
    }
    if (mode === "decade") {
      panel = (
        <DecadePanel
          locale={locale}
          defaultValue={value}
          rootPrefixCls={prefixCls}
          onSelect={this.onDecadeSelect}
        />
      )
    }

    return (
      <div className={`${prefixCls}-header`}>
        <div style={{ position: "relative" }}>
          {showIf(
            enablePrev && !showTimePicker,
            <a
              className={`${prefixCls}-prev-year-btn`}
              role="button"
              onClick={this.previousYear}
              title={locale.previousYear}
            />,
          )}
          {showIf(
            enablePrev && !showTimePicker,
            <a
              className={`${prefixCls}-prev-month-btn`}
              role="button"
              onClick={this.previousMonth}
              title={locale.previousMonth}
            />,
          )}
          {this.monthYearElement(showTimePicker)}
          {showIf(
            enableNext && !showTimePicker,
            <a
              className={`${prefixCls}-next-month-btn`}
              onClick={this.nextMonth}
              title={locale.nextMonth}
            />,
          )}
          {showIf(
            enableNext && !showTimePicker,
            <a
              className={`${prefixCls}-next-year-btn`}
              onClick={this.nextYear}
              title={locale.nextYear}
            />,
          )}
        </div>
        {panel}
      </div>
    )
  },
})

export default CalendarHeader
